import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Whether new chat sessions opt into the runtime's built-in `image_generation` tool.
 *
 * Reading a feature flag touches client env, which throws if it isn't ready yet.
 * Treat "env not ready" as flag-off so an unseeded env can't break session setup.
 */
export function isImageGenerationEnabled(): boolean {
  try {
    return isFeatureEnabled('one_copilot_image_generation')
  } catch {
    return false
  }
}
